import axios, { AxiosResponse } from 'axios';
import { apiClient } from '../endpoints';
import { User } from '../users';

export interface DashboardValidationStats {
    conducId: string;
    nbActivitiesValidated: number;
    nbActivitiesInValidation: number;
    conduc: User;
}

export interface DashboardValidationResponse {
    message: string;
    data: DashboardValidationStats[];
}

export const getDashboardValidationStats = async (date: string): Promise<DashboardValidationResponse> => {
    try {
        const response: AxiosResponse<DashboardValidationResponse> = await apiClient.get(`/dashboard/validation`, { params: { date } });
        return response.data;
    } catch (error: any) {
        if (axios.isAxiosError(error) && error.response) {
            throw new Error(error.response.data.message || 'Erreur API');
        } else {
            throw new Error('Erreur inattendue');
        }
    }
};

export interface AbsentReportsData {
    absentReportsCount: number;
    reportsCount: number;
}

export interface AbsentReportsResponse {
    message: string;
    data: AbsentReportsData;
}

export const getAbsentReportsStats = async (date: string): Promise<AbsentReportsResponse> => {
    try {
        const response: AxiosResponse<AbsentReportsResponse> = await apiClient.get('/dashboard/absent-reports', {
            params: { date },
        });
        return response.data;
    } catch (error: any) {
        if (axios.isAxiosError(error) && error.response) {
            throw new Error(error.response.data.message || 'Erreur API');
        } else {
            throw new Error('Erreur inattendue');
        }
    }
};

export interface DailyExpense {
    day: string;
    total: number;
}

export interface MonthlyExpensesResponse {
    message: string;
    data: DailyExpense[];
}

export const getMonthlyExpenses = async (date: string): Promise<MonthlyExpensesResponse> => {
    try {
        const response: AxiosResponse<MonthlyExpensesResponse> = await apiClient.get('/dashboard/monthly-expenses', {
            params: { date },
        });
        return response.data;
    } catch (error: any) {
        if (axios.isAxiosError(error) && error.response) {
            throw new Error(error.response.data.message || 'Erreur API');
        } else {
            throw new Error('Erreur inattendue');
        }
    }
};
